import { CardModel, CardShift, PileCardModel } from "../../interface/game";
import { SequencePolicy } from "../pile-sequence/sequence-policy";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function pileContiguousDragPolicy(sequencePolicy: SequencePolicy): PileAnnotationPolicy {
    return (pile: PileCardModel[], cards: {[key: string]: CardModel}): PileCardModel[] => {
        const pileCards: PileCardModel[] = [];

        if (pile.length === 0) {
            return pileCards;
        }

        const cardStack = [...pile];
        const card = cardStack.pop() as PileCardModel;
        let cardModel = cards[card.id];
        let isDraggable = cardModel.faceUp && cardModel.shift === CardShift.OPEN;
 
        pileCards.unshift({...card, draggable: isDraggable});

        while (cardStack.length > 0) {
            const cardAbove = cardModel;
            const card = cardStack.pop() as PileCardModel;
            cardModel = cards[card.id];
            isDraggable = isDraggable 
                && cardModel.faceUp 
                && cardModel.shift === CardShift.OPEN 
                && sequencePolicy(cardModel, cardAbove);

            pileCards.unshift({...card, draggable: isDraggable});
        }

        return pileCards;
    }
}